import { Component } from 'react';
import { string } from 'prop-types';
import { Button } from '@fff-web/fff-ui-shared';
import env from '../../../utils/env';
import { trackExpiredReactivateStarted } from '../../../utils/analytics';
import Detail from '../Detail/Detail';

class UpgradeMembership extends Component {
  static get propTypes() {
    return {
      cta: string.isRequired,
      desc: string.isRequired,
      title: string.isRequired,
    };
  }

  showPopupContent = () => {
    // Wordpress popup integration hack
    // This should not carry over once we move the popup to React
    const popup = document.querySelector('.pum-content.popmake-content .not-for-expired');
    if (popup) {
      popup.classList.remove('not-for-expired');
    }
  };

  handleClickReactivate = (cta) => {
    trackExpiredReactivateStarted(cta).finally(() => {
      window.location = `${env.envURL}/reactivate-my-membership`;
    });
  };

  render() {
    const { cta, desc, title } = this.props;

    return (
      <Detail icon="fa-star" title={title} description={desc}>
        <Button
          data-testid="header-reactivate-cta"
          width="100%"
          style={{
            marginTop: '16px',
          }}
          onClick={() => this.handleClickReactivate(cta)}
        >
          {cta}
        </Button>
      </Detail>
    );
  }
}

export default UpgradeMembership;
